import React from 'react';
import type { ReactElement } from 'react';
import {
  TooltipContent,
  TooltipRoot,
  TooltipTrigger,
} from '@socialchorus/shared-ui-components';
import { useFollowChannelButtonState } from '../../common/channel/use-follow-channel-button-state';

type ChannelButtonTooltipProps = {
  channelId: number | string;
  children: ReactElement;
};

export const ChannelButtonTooltip = ({
  channelId,
  children,
}: ChannelButtonTooltipProps) => {
  const { tooltip } = useFollowChannelButtonState({ channelId });

  if (!tooltip) return children;

  return (
    <TooltipRoot>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        // z-index must be higher than the z-index of the assistant chat
        style={{ zIndex: 2100 }}
        side="top"
        align="center"
        sideOffset={5}
        description={tooltip}
      />
    </TooltipRoot>
  );
};
